const PIN_ACCESS_CACHE_KEY = "pin_access_granted";

export const getCachedPinAccess = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(PIN_ACCESS_CACHE_KEY) === "true";
  } catch {
    return false;
  }
};

export const setCachedPinAccess = (value: boolean): void => {
  if (typeof window === "undefined") return;
  try {
    if (value) {
      localStorage.setItem(PIN_ACCESS_CACHE_KEY, "true");
    } else {
      localStorage.removeItem(PIN_ACCESS_CACHE_KEY);
    }
  } catch {
    // ignore storage errors
  }
};

export const clearCachedPinAccess = (): void => {
  setCachedPinAccess(false);
};
